import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
    const [user, setUser] = useState(null);
    const [userToken, setUserToken] = useState(localStorage.getItem('token') || '');
    const [role, setRole] = useState(localStorage.getItem('role') || '');  
    const [loading, setLoading] = useState(true);

    const login = (data) => {
        const token = data.token.split('|')[1];
        localStorage.setItem('token', token);
        localStorage.setItem('role', data.user.role_type);  
        setUser(data.user);
        setRole(data.user.role_type); 
        setIsAuthenticated(true);
        setUserToken(token);
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('role');  
        setIsAuthenticated(false);
        setRole('');
        setUser(null);
        setUserToken('');
    };

    const authAxios = axios.create();
    authAxios.interceptors.request.use((config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });

    useEffect(() => {
        const validateToken = async () => {
            const token = localStorage.getItem('token');
            if (token) {
                try {
                    // Replace with your API endpoint to get user info
                    const response = await axios.get('/api/user', {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    const userData = response.data;
                    setUser(userData);
                    setRole(userData.role_type);
                    setIsAuthenticated(true);
                } catch (error) {
                    console.error('Token validation failed', error);
                    logout();
                }
            } else {
                logout();
            }
            setLoading(false);
        };
        validateToken();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, authAxios, user, role }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
